import { Reducer, combineReducers } from 'redux'
import { CartUIState, CartActionTypes } from './types'

// Type-safe initialState!
const initialState: CartUIState = {
    processing: false,
    processState : 0,  // 0: Initial, 1: Success, 2: Failed
    errors: undefined,
    data: undefined
}

const ui: Reducer<CartUIState> = (state = initialState, action) => {
    switch (action.type) {
        // Get Discount
        case CartActionTypes.GETDISCOUNT_REQUEST: {
            return { ...state, processing: true, processState: 0 };
        }
        case CartActionTypes.GETDISCOUNT_SUCCESS: {
            return { ...state, processing: false, processState: 1, data: action.payload };
        }
        case CartActionTypes.GETDISCOUNT_ERROR: {
            return { ...state, processing: false, processState: 2, errors: action.payload.error }
        }
        default: {
            return state
        }
    }
}

const byId: Reducer<{}> = (state = {}, action) => {
    switch (action.type) {
        default: {
            return state
        }
    }
}

const allIds: Reducer<string[]> = (state = [], action) => {
    switch (action.type) {
        default: {
            return state
        }
    }
}
// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
const CartsReducer = combineReducers({
    ui,
    byId,
    allIds,
    // byCategory,
    // Category
})
export default CartsReducer
